import { ActionTree, GetterTree, MutationTree } from 'vuex';

import { SalesOnboardingFormState } from '@/models/sales-onboarding';
import { IRouterProps } from '@/router/interfaces/router-props.interface';

import { RootState } from '../types';
import Module from '../interfaces/module.interface';

export const SALES_ONBOARDING_STORAGE_KEY = '@twism:sales-onboarding-store';

const initialState = (): SalesOnboardingFormState => ({
  inviteCode: '',
  welcomeCoins: {
    enabled: false,
    value: ''
  },
  sellCoins: false
});

export const setSalesOnboardingDataOnSessionStorage = (
  state: SalesOnboardingFormState
) => {
  sessionStorage.setItem(SALES_ONBOARDING_STORAGE_KEY, JSON.stringify(state));
};

export const getSalesOnboardingDataFromSessionStorage = (): SalesOnboardingFormState => {
  return JSON.parse(
    sessionStorage.getItem(SALES_ONBOARDING_STORAGE_KEY) ||
      JSON.stringify(initialState())
  );
};

export const removeSalesOnboardingDataOnSessionStorage = () => {
  sessionStorage.removeItem(SALES_ONBOARDING_STORAGE_KEY);
};

const factory = async (context: IRouterProps) => {};

const getters: GetterTree<SalesOnboardingFormState, RootState> = {
  getFormData: state => state
};

const actions: ActionTree<SalesOnboardingFormState, RootState> = {
  SET_FORM_DATA({ commit }, payload: Partial<SalesOnboardingFormState>) {
    commit('setFormData', payload);
  },
  RESET_FORM_DATA({ commit }) {
    commit('resetFormData');
  }
};

const mutations: MutationTree<SalesOnboardingFormState> = {
  setFormData(state, formData: Partial<SalesOnboardingFormState>) {
    Object.assign(state, formData);
    setSalesOnboardingDataOnSessionStorage(state);
  },
  resetFormData(state) {
    Object.assign(state, initialState());
    setSalesOnboardingDataOnSessionStorage(state);
  }
};

export const salesOnboarding: Module<SalesOnboardingFormState, RootState> = {
  namespaced: true,
  initializer: {
    factory,
    provide: 'SalesOnboardingStore',
    on: 'BeforeEachRoute'
  },
  state: getSalesOnboardingDataFromSessionStorage(),
  getters,
  actions,
  mutations
};
